export class Log {
  logId: number;
  utilisateurUsername: string;
  date: Date;
  type: string;
  fonction: string;
  message: string;
}
